import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    section: {
      margin: theme.spacing(2)
    },
    sectionContent: {
      paddingTop: 0
    },
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(2)
    },
    loading: {
      marginTop: theme.spacing(10)
    },
    storeSelect: {
      display: "flex",
      justifyContent: "center"
    },
    deadlinePassed: {
      color: "red"
    },
    createOrderResult: {
      width: "100%",
      "& > * + *": {
        marginTop: theme.spacing(2)
      }
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    spinnerContainer: {
      position: "absolute",
      backgroundColor: "rgba(255,255,255,0.8)",
      zIndex: 100,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "& .MuiCircularProgress-root": {
        position: "fixed",
        top: "50%"
      }
    }
  })
);
